import React, { useState, useEffect } from 'react';
import AppSidebar from './AppSidebar';
import { Navbar } from './common/Catalyst/navbar';
import { SidebarLayout } from './common/Catalyst/sidebar-layout';
import ViolationList from './ViolationList';
import { ViolationKanbanBoard } from './violation/ViolationKanbanBoard';
import { ViewSwitch, ListViewMode } from './violation/linear/ViewSwitch';

// 'list' is the grouped list (#603); Kanban stays as the alternative.
// A saved 'table' predates the grouped list and means the same view.
type ViewMode = ListViewMode;

const VIEW_MODE_KEY = 'violationViewMode';

interface ViolationPageProps {
  currentPage: string;
}

const ViolationPage: React.FC<ViolationPageProps> = ({ currentPage }) => {
  const [viewMode, setViewMode] = useState<ViewMode>(() => {
    try {
      return localStorage.getItem(VIEW_MODE_KEY) === 'kanban' ? 'kanban' : 'list';
    } catch {
      return 'list';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(VIEW_MODE_KEY, viewMode);
    } catch {
      // Storage unavailable: the choice lasts for this page only.
    }
  }, [viewMode]);

  const switcher = <ViewSwitch value={viewMode} onChange={setViewMode} />;

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
      // Both views use the whole panel and scroll inside themselves; the
      // page never scrolls on desktop. Both run to the panel's edges, with
      // their toolbar as the top row (Linear's views); the board's
      // columns keep a gutter below it.
      fill
      flush
    >
      {/* No page heading: the sidebar already says where you are, and the
          view's own toolbar (the filter bar, or the bar over the board)
          carries the view switch. */}
      <div className="flex min-h-0 flex-1 flex-col">
        {viewMode === 'list' ? (
          <ViolationList fill flush showTitle={false} toolbar={switcher} />
        ) : (
          <ViolationKanbanBoard fill flush toolbar={switcher} />
        )}
      </div>
    </SidebarLayout>
  );
};

export default ViolationPage;
